import { render, staticRenderFns } from "./MyComponentModal.vue?vue&type=template&id=35bea9a0"
import script from "./MyComponentModal.vue?vue&type=script&lang=js"
export * from "./MyComponentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports